import * as React from 'react';

import EnvelopeBadge16 from './EnvelopeBadge16';

export const envelopeBadge16 = () => <EnvelopeBadge16 />;

export default {
    title: 'Icon/Line/EnvelopeBadge16',
    component: EnvelopeBadge16,
    parameters: {
        notes: "`import EnvelopeBadge16 from 'box-ui-elements/es/icon/line/EnvelopeBadge16';`",
    },
};
